import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { View, Text } from 'react-native-web';

import DISCOVER_SKILL_LEVELS from '../../../graphql/DISCOVER_SKILL_LEVELS';
import { Button } from '../../../../shared-components/base-components';
import { useSelectedParams } from '../../../../hooks';

import styles from '../styles';

const propTypes = {
  onPress: PropTypes.func,
  cityName: PropTypes.string,
  selectedSkillLevels: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  onPress: undefined,
  cityName: '',
  selectedSkillLevels: undefined,
};

const SkillLevelFilter = ({ onPress, cityName, selectedSkillLevels }) => {
  const [selected, setSelected] = useSelectedParams(selectedSkillLevels, onPress);

  const currentSkillLevels = selectedSkillLevels || selected;

  const { data, error } = useQuery(DISCOVER_SKILL_LEVELS, {
    skip: !cityName,
    fetchPolicy: 'cache-and-network',
    variables: { input: { cityName } },
  });

  if (error) {
    return (
      <View>
        <Text>{error.message}</Text>
      </View>
    );
  }

  const skillLevels = data?.discoverSkillLevels?.skillLevels;

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        {skillLevels?.map(level => (
          <Button
            key={level}
            value={level}
            variant="outline"
            onPress={() => setSelected(level)}
            pressed={currentSkillLevels.includes(level)}
            style={styles.button}
          />
        ))}
      </View>
    </View>
  );
};

SkillLevelFilter.propTypes = propTypes;
SkillLevelFilter.defaultProps = defaultProps;

export default SkillLevelFilter;
